/* eslint-disable */

import type { Config } from "@wagmi/core"
import type { Address } from "viem"
import { multicall } from "@wagmi/core"

import type { Token } from "@/domains/core"
import { minimalTokenAbi } from "@/domains/abis"

import type { CreateLockLensResult, MulticallContractConfig } from "../types"
import { BIGINT_ZERO } from "../constants"
import { makeWeiReturnObject } from "../make-wei-return-object"

type CreateLockLensParams = {
  account: Address
  governanceToken: Token
  vestedToken: Token
  chainId: number
  config: Config
}

export const createLockLensDefaultValue: CreateLockLensResult = {
  accountBalanceToken: { wei: BIGINT_ZERO, value: "0" },
  vestedSpendTokenAllowance: { wei: BIGINT_ZERO, value: "0" },
}

/**
 * This is now an sync function that can be called via useQuery
 */
export const createLockLens = async ({
  account,
  chainId,
  config,
  governanceToken,
  vestedToken,
}: CreateLockLensParams): Promise<CreateLockLensResult> => {
  try {
    const contracts: MulticallContractConfig[] = [
      {
        address: governanceToken.address,
        abi: minimalTokenAbi,
        functionName: "balanceOf",
        args: [account],
        chainId: chainId,
      },
      {
        address: governanceToken.address,
        abi: minimalTokenAbi,
        functionName: "allowance",
        args: [account, vestedToken.address],
        chainId: chainId,
      },
    ]
    // @ts-ignore
    const lens = await multicall(config, { contracts })

    return {
      accountBalanceToken: makeWeiReturnObject(lens[0]?.result as bigint, governanceToken.decimals),
      vestedSpendTokenAllowance: makeWeiReturnObject(lens[1]?.result as bigint, governanceToken.decimals),
    }
  } catch (error: any) {
    console.error("useCreateLockLens", error)
    return createLockLensDefaultValue
  }
}
